import { render, staticRenderFns } from "./roleModal.vue?vue&type=template&id=8f0fa93a&scoped=true"
import script from "./roleModal.vue?vue&type=script&lang=js"
export * from "./roleModal.vue?vue&type=script&lang=js"
import style0 from "./roleModal.vue?vue&type=style&index=0&id=8f0fa93a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0fa93a",
  null
  
)

export default component.exports